/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesLt = {
  privacy: {
    pageTitle: "Privatumo politika",
    lastUpdated: "Paskutinį kartą atnaujinta: 2026 m. birželio 1 d.",
    introduction: {
      title: "Įvadas",
      body: "WasOK yra vietinė pirmumo tvarka veikianti apsipirkimo pagalbinė programa, skirta padėti vartotojams prisiminti produktus, kuriuos jie anksčiau pirko, įvertino arba apžvelgė.\n\nŠi privatumo politika paaiškina, kokia informacija apdorojama naudojant programėlę, kaip duomenys saugomi ir kaip gali veikti tam tikros trečiųjų šalių paslaugos.",
    },
    dataStored: {
      title: "Programėlės saugomi duomenys",
      body: "WasOK vietiniu būdu jūsų įrenginyje saugo šią informaciją:\n\n• nuskaitytus produktų brūkšninius kodus\n• vartotojo įvestus produktų pavadinimus ir detales\n• įvertinimus ir komentarus\n• pirkinių sąrašus\n• produktų kategorijas\n• kainas ir parduotuvių informaciją\n• produktų ir parduotuvių nuotraukas\n\nJūsų produktų duomenys ir nuotraukos nėra įkeliami į WasOK serverius.",
    },
    permissions: {
      title: "Naudojami leidimai",
      camera: {
        title: "Kamera",
        body: "Prieiga prie kameros naudojama:\n\n• brūkšninių kodų nuskaitymui\n• produktų nuotraukų darymui",
      },
      photos: {
        title: "Nuotraukos ir medija",
        body: "Prieiga prie nuotraukų ar galerijos naudojama tik kai:\n\n• prie produktų pridedate vaizdus\n• atkuriate atsargines kopijas su nuotraukomis",
      },
      files: {
        title: "Prieiga prie failų ir saugyklos",
        body: "Prieiga prie failų gali būti naudojama:\n\n• atsarginių kopijų failų eksportavimui\n• vartotojo pasirinktų atsarginių kopijų importavimui\n• pirkinių sąrašų ar atsarginių kopijų dalijimuisi",
      },
    },
    backup: {
      title: "Atsarginės kopijos ir eksportavimas",
      body: "WasOK leidžia vartotojams kurti atsarginių kopijų failus su programėlės duomenimis ir pasirenkamomis nuotraukomis.\n\nAtsarginių kopijų failai kuriami vietiniu būdu jūsų įrenginyje ir gali būti saugomi ar dalijami naudojant vartotojo pasirinktas paslaugas, pavyzdžiui:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• vietinę įrenginio saugyklą\n\nWasOK neįkelia atsarginių kopijų į savo serverius.",
      onlineProductLookup: {
        title: "Produktų paieška internete",
        body: "Kai Nuostatose įjungiate brūkšninių kodų paiešką internete, WasOK gali nusiųsti tik nuskaityto brūkšninio kodo numerį į viešąsias produktų duomenų bazes (pavyzdžiui, Open Food Facts), kad pasiūlytų produkto pavadinimą ir prekės ženklą. WasOK neįkelia jūsų įvertinimų, komentarų, nuotraukų, pirkinių sąrašų, kategorijų, parduotuvių informacijos ar atsarginių kopijų duomenų šiai funkcijai. Tai galite bet kada išjungti Nuostatose.",
      },
    },
    advertising: {
      title: "Reklama ir trečiųjų šalių paslaugos",
      intro:
        "WasOK naudoja atrinktas trečiųjų šalių paslaugas tam tikroms funkcijoms teikti.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob naudojama reklamoms programėlėje rodyti.\n\nGoogle ir jos partneriai gali apdoroti tokią informaciją kaip:\n\n• reklamos identifikatoriai\n• įrenginio informacija\n• IP adresas\n• diagnostikos ir naudojimo informacija\n\nTam tikrų regionų vartotojų gali būti prašoma sutikimo prieš rodant suasmenintas reklamas.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK naudoja Firebase Crashlytics, kad padėtų nustatyti gedimus ir pagerinti programėlės stabilumą.\n\nGedimų ataskaitose gali būti techninė informacija, pavyzdžiui:\n\n• įrenginio modelis\n• operacinės sistemos versija\n• programėlės versija\n• gedimų diagnostika\n\nGedimų ataskaitose tyčia nėra jūsų produktų įvertinimų, pastabų, pirkinių sąrašų ar nuotraukų.",
      },
      externalProductDatabases: {
        title: "Išorinės produktų duomenų bazės",
        body: "Brūkšninių kodų paieškos funkcija gali naudoti išorines produktų duomenų bazes produktų informacijai gauti.\n\nDaugiau informacijos rasite atitinkamų teikėjų privatumo politikose.",
      },
    },
    dataSecurity: {
      title: "Duomenų saugumas",
      body: "WasOK saugo programėlės duomenis vietiniu būdu jūsų įrenginyje naudodama operacinės sistemos teikiamus saugojimo mechanizmus.\n\nNors imamasi pagrįstų priemonių vietiniams programėlės duomenims apsaugoti, joks elektroninio saugojimo metodas nėra visiškai saugus.\n\nVartotojai yra atsakingi už svarbių duomenų atsarginių kopijų palaikymą, jei to pageidauja.",
    },
    children: {
      title: "Vaikų privatumas",
      body: "WasOK nėra skirta vaikams iki 13 metų.",
    },
    notifications: {
      title: "Pranešimai",
      body: "WasOK gali pasirinktinai kurti vietinius pranešimus jūsų įrenginyje, primenančius įvertinti produktus po pirkimo.\n\nŠie pranešimai generuojami ir planuojami vietiniu būdu jūsų įrenginyje ir nereikalauja paskyros ar nuotolinio serverio.\n\nPranešimus galite bet kada išjungti įrenginio nustatymuose arba programėlėje, jei tai palaikoma.",
    },
    yourControl: {
      title: "Jūsų kontrolė duomenims",
      body: "Galite:\n\n• bet kada redaguoti arba ištrinti saugomus produktus\n• išvalyti programėlės duomenis iš įrenginio\n• išdiegti programėlę\n• eksportuoti savo duomenų atsargines kopijas",
    },
    changes: {
      title: "Šios politikos pakeitimai",
      body: "Ši privatumo politika gali būti kartais atnaujinama.\n\nPakeitimai įsigalioja, kai paskelbiama atnaujinta versija.",
    },
    contact: {
      title: "Kontaktai",
      body: "Jei turite klausimų dėl šios privatumo politikos, susisiekite:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Paslaugų teikimo sąlygos",
    lastUpdated: "Paskutinį kartą atnaujinta: 2026 m. birželio 1 d.",
    acceptance: {
      title: "Sąlygų priėmimas",
      body: "Atsisiųsdami, įdiegdami ar naudodami WasOK sutinkate su šiomis paslaugų teikimo sąlygomis.\n\nJei nesutinkate su šiomis sąlygomis, neturėtumėte naudoti programėlės.",
    },
    license: {
      title: "Licencija",
      body: "WasOK suteikia jums ribotą, neišimtinę, neperleidžiamą, atšaukiamą licenciją naudoti programėlę pagal šias sąlygas.",
    },
    acceptableUse: {
      title: "Priimtinas naudojimas",
      body: "Sutinkate:\n\n• nepiktnaudžiauti programėle\n• netrukdyti programėlės veikimui\n• nebandyti atvirkštinės inžinerijos ar keisti programėlės\n• nenaudoti programėlės pažeidžiant taikomus įstatymus ar reglamentus",
    },
    localData: {
      title: "Vietiniai duomenys ir atsarginės kopijos",
      body: "WasOK saugo vartotojo duomenis vietiniu būdu įrenginyje.\n\nVartotojai yra atsakingi už svarbių duomenų atsarginių kopijų palaikymą, jei to pageidauja.\n\nNors gali būti teikiama atsarginių kopijų ir atkūrimo funkcija, WasOK negarantuoja apsaugos nuo saugomų duomenų praradimo, sugadinimo ar gedimo.",
    },
    advertisements: {
      title: "Reklamos",
      body: "Programėlė gali rodyti trečiųjų šalių reklamos partnerių, įskaitant Google AdMob, teikiamas reklamas.",
    },
    noWarranty: {
      title: "Jokios garantijos",
      body: "WasOK teikiama „tokia, kokia yra“ ir „kaip prieinama“ be jokių išreikštų ar numanomų garantijų.\n\nMes negarantuojame, kad:\n\n• programėlė visada bus prieinama\n• programėlė bus be klaidų\n• duomenų praradimas niekada neįvyks\n• visos funkcijos veiks be pertrūkių visuose įrenginiuose",
    },
    limitationLiability: {
      title: "Atsakomybės apribojimas",
      body: "Didžiausiu įstatymų leidžiamu mastu WasOK ir jos kūrėjai neatsako už:\n\n• duomenų praradimą\n• pelno praradimą\n• įrenginio problemas\n• netiesioginę ar pasekminę žalą\n• pertraukimus dėl programėlės naudojimo ar negalėjimo ja naudotis",
    },
    thirdParty: {
      title: "Trečiųjų šalių paslaugos",
      body: "Tam tikros funkcijos ar turinys gali priklausyti nuo trečiųjų šalių paslaugų, įskaitant reklamos teikėjus ir vartotojo pasirinktas išorines saugojimo / dalijimosi paslaugas.\n\nWasOK nėra atsakinga už trečiųjų šalių paslaugas ar jų politiką.",
    },
    productInformation: {
      title: "Produktų informacija",
      body: "Tam tikros produktų detalės gali būti gaunamos iš trečiųjų šalių brūkšninių kodų paieškos paslaugų.\n\nWasOK negarantuojama išorinių duomenų šaltinių teikiamos informacijos tikslumas, išsamumas, prieinamumas ar tinkamumas.\n\nVartotojai turėtų prireikus savarankiškai patikrinti produktų informaciją.",
    },
    changesApp: {
      title: "Programėlės pakeitimai",
      body: "WasOK gali būti keičiama, atnaujinama, laikinai sustabdyta arba nutraukta bet kuriuo metu be išankstinio įspėjimo.",
    },
    changesTerms: {
      title: "Šių sąlygų pakeitimai",
      body: "Šios sąlygos gali būti periodiškai atnaujinamos.\n\nTolesnis programėlės naudojimas po to, kai atnaujinimai įsigalioja, reiškia sutikimą su peržiūrėtomis sąlygomis.",
    },
    contact: {
      title: "Kontaktai",
      body: "Klausimais dėl šių sąlygų kreipkitės:\n\nsupport@wasok.app",
    },
  },
};
